import { render } from "./ReplaceVodModal.vue?vue&type=template&id=94798364"
import script from "./ReplaceVodModal.vue?vue&type=script&lang=js"
export * from "./ReplaceVodModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__